import React from "react";

export function FormSection({ title, description, children, testId }) {
  return (
    <section data-testid={testId} className="hah-card p-6">
      <div className="mb-5">
        <h3 className="text-base font-semibold text-[#1F2937]">{title}</h3>
        {description && <p className="mt-1 text-sm text-[#6B7280]">{description}</p>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {children}
      </div>
    </section>
  );
}

export function FormField({ label, required, error, hint, children, full, testId }) {
  return (
    <div data-testid={testId} className={full ? "md:col-span-2" : ""}>
      <label className="block text-sm font-medium text-[#1F2937] mb-1.5">
        {label}
        {required && <span className="text-[#EF4444] ml-1">*</span>}
      </label>
      {children}
      {hint && !error && <div className="mt-1 text-xs text-[#6B7280]">{hint}</div>}
      {error && <div className="mt-1 text-xs text-[#EF4444]">{error}</div>}
    </div>
  );
}

export function StickyActionBar({ children, testId }) {
  return (
    <div data-testid={testId || "sticky-action-bar"} className="hah-sticky-bar mt-6 -mx-8 px-8 py-3 flex items-center justify-end gap-3">
      {children}
    </div>
  );
}
